export default __webpack_public_path__ + "static/media/hra-guide.d7cfcaff.svg";